<template>
  <div class="catalog-wrap" v-show="loading">
    <div class="catalog-wrap__page">{{mediaInfo.courseUpdateText}}</div>
      <template v-if="audioList.length">
        <SubsectionAudio
          v-for="(audio, index) in audioList"
          :audio="audio"
          :index="index"
          :key="audio.courseSection+'-'+index"
          @onJump="openApp"/>
      </template>

      <template v-if="videoList.length">
        <SubsectionVideo
          v-for="(video, index) in videoList"
          :video="video"
          :key="video.videoPid + '-' + index"
          @onJump="openApp"/>
      </template>

      <div class="catalog-wrap__bottom" v-if="mediaInfo.bottomText">{{mediaInfo.bottomText}}</div>
  </div>
</template>

<script>
import SubsectionAudio from './subsectionAudio';
import SubsectionVideo from './subsectionVideo';
import { getCourseDirectoryList } from '@/api/goods';
import { env, coolHref, JS2Native, webSDK } from '@igetcool/base-components';
import { findComponentUpwardByEvent } from '@/utils/tool';

export default {
  name: 'CourseCatalog',
  components: {
    SubsectionAudio,
    SubsectionVideo,
  },
  props: {
    courseId: {
      type: String,
      default: ''
    },
    productType: {
      type: [String, Number],
      default: '',
    },
    // 是否购买
    boughtCount: {
      type: [String, Number],
      default: 0,
    },
    // 是否登陆
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      audioList: [],
      videoList: [],
      mediaInfo: {
        bottomText: '',
        courseUpdateText: ''
      }
    };
  },
  computed: {
    isVideo() {
      return this.videoList.length;
    }
  },
  created() {
    // 产品类型 0-有声书 1-音频课 2-直播课 3-视频课 8-阅读计划 10 实体 11- 课包  200 家长课 300 公司活动 600 训练营
    this.getMedia();
  },
  methods: {
    getMedia() {
      if (!this.courseId) {
        return;
      }
      const params = {
        jump: 1,
        infoId: this.courseId,
      };
      Promise.all([getCourseDirectoryList(this.courseId), this.$store.dispatch('acOpenApp', params)]).then(([res, url]) => {
        // 获取音视频目录
        const { audioList, pointList, audioUpdateInfo, courseUpdateText } = res.data;
        this.mediaInfo.bottomText = audioUpdateInfo;
        this.mediaInfo.courseUpdateText = courseUpdateText;

        const audioListObj = (data) => {
          if (!data) {
            return [];
          }
          return data.reduce((pre, cur) => {
            if (cur.list && cur.list.length) {
              return pre = [...pre, ...cur.list];
            }
            return pre;
          }, []);
        };

        if (audioList) {
          this.audioList = audioListObj(audioList);
        }
        if (pointList) {
          this.videoList = audioListObj(pointList);
        }

        // 获取课程scame地址
        this.openUrl = url;
        this.loading = true;
      });
    },

    // type 1: 音频 2: 视频
    openApp({ type, data, index = index }) {
      // const dataForAppObj = {
      //   'moduleTitle': null,
      //   'audioType': '0',
      //   'modulePid': '0',
      //   'defaultSelectIndex': 0,
      //   'list': this.audioList
      // };

      // JS2Native({
      //   name: 'mediaControl',
      //   params: {
      //     dataForApp: JSON.stringify(dataForAppObj),
      //     code: 1,
      //     method: 'play',
      //   }
      // });

      // 埋点上报
      try {
        const parents = findComponentUpwardByEvent(this, 'setLogTrack');
        if (parents) {
          parents.setLogTrack({
            module_name: '目录小节',
            btn_name: type === 1 ? '试听' : '试看',
            key1: {
              item_id: data.audioPid || data.videoPid,                // 小节id
              item_name: data.audioTitle || data.videoTitle,          // 小节名称
              item_type: type,                                        // 音频，2视频
              item_status: (data.audioFree || data.free) ? 1 : 2,    // 1试听，2 锁定
            }
          }, 'click');
        }
      } catch (error) {
      }

      // 一、试听部分逻辑
      // 1、不区分是否登陆
      // 2、音频在端内、端外都用h5播放
      if (type === 1 && data.audioFree) {
        return;
      }

      // 二、试听部分逻辑
      // 1、在端外，跳到主站的试看页面
      // 2、在端内，跳到原生页面
      if (type === 2 && data.free) {
        if (env.isApp) {
          coolHref(`igetcool://juvenile.dedao.live/demand/paid/play?params_uuid=${data.coursePid}&chapterPid=${data.videoPid}`);
        } else {
          window.location.href = `${window.location.origin}/courseSingleVideo?videoPid=${data.videoPid}&coursePid=${data.coursePid}&openUrl=${encodeURIComponent(this.openUrl)}`;
        }
        return;
      }

      // 三、非试听、非试看部分逻辑

      // 1、未登陆 且 非试听 非试看 引导去登陆
      if (!this.isLogin && !data.free && !data.audioFree) {
        this.jumpLogin();
        return;
      }

      // 2、已登陆 未购买 提示“购买后即可解锁全部课程哦！”
      if (!this.boughtCount) {
        const query = this.$route.query;
        const tip = query.ptFlag ? '团成后即可结算全部课程' :  '购买后即可解锁全部课程哦！';
        // 开团、参团页面提示
        this.$coolToast({
          text: tip,
          time: 1000
        });
        return;
      }

      // 四、已购买逻辑
      // 1、端内提示去学习
      if (env.isApp) {
        this.$coolToast({
          text: '请点击去学习',
          time: 1000
        });
        return;
      }
      // 2、端外，跳到端内
      webSDK.openApp(this.openUrl, { invokeFailShowGuide: true });
    },

    jumpLogin() {
      if (env.isApp) {
        JS2Native({
          name: 'doLogin'
        }).then(res => {
          if (res.data) {
            window.location.reload();
          }
        });
      } else {
        const search = location.search;
        const redirect = location.pathname;
        this.$router.push({
          path: `/mall/login${search ? `${search}&` : '?'}redirect=${redirect}`,
        });
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.catalog-wrap {
  padding: 0 20px;
  background: #fff;
  .catalog-wrap__page {
    height: 50px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a1a1b3;
    line-height: 50px;
  }
  .catalog-wrap__bottom {
    padding: 26px 0 30px;
    line-height: 26px;
    color: #6d6d80;
    font-size: 14px;
    text-align: center;
  }
}
</style>